import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '@app/core/auth/auth-guard.service';
import { ErrorComponent } from '@app/core/components/error/error.component';
import { SessionTimedOutPageComponent } from '@app/core/components/session-timed-out-page/session-timed-out-page.component';
import { PackageErrorComponent } from '@app/core/components/package-error/package-error.component';
import { FinishPageComponent } from '@app/core/components/finish-page/finish-page.component';
import { RedirectGuardService } from '@app/core/services/redirect-guard.service';
import { PageNotFoundComponent } from '@app/core/components/page-not-found/page-not-found.component';

const appRoutes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('app/modules/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'sign',
    loadChildren: () => import('app/modules/sign/sign.module').then((m) => m.SignModule),
    canActivate: [AuthGuardService],
    data: { preload: true },
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  {
    path: 'session-expired',
    component: SessionTimedOutPageComponent,
  },
  {
    path: 'package-error',
    component: PackageErrorComponent,
  },
  // {
  //    path: 'create',
  //    loadChildren: 'app/modules/create/create.module#CreateModule',
  //    canActivate: [AuthGuardService]
  // },
  // {
  //    path: 'user',
  //    loadChildren: 'app/modules/user/user.module#UserModule',
  //    canActivate: [AuthGuardService]
  // },
  {
    path: 'finish',
    component: FinishPageComponent,
    canActivate: [RedirectGuardService],
  },
  {
    path: '',
    redirectTo: '/finish',
    pathMatch: 'full',
  },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      // {
      // preloadingStrategy: SelectivePreloadingStrategy
      // ,useHash: true //Use for IIS
      // ,
      // relativeLinkResolution: 'legacy'
      // }
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
